import {post,get} from "../../../utils/request";
import axios from 'axios';
import {API_PAY, USER_INFO} from '../../../utils/api';

export const getPayParams = (params) => {
    return async (dispatch) => {
        const result = await getWechatParams(params);
        return result;
    }
};

export const getUserInfo = (params) => {
    return (dispatch) => {
        return post(USER_INFO, params)
            .then((response) => {
                return response.data;
            });
    }
};

const getWechatParams = (params) => {
    let token = Storage.Base.getInstance().get('_loginTk');
    if (!token) {
        token = "";
    }
    return axios({
        method: 'post',
        url: API_PAY,
        data: JSON.stringify(params),
        headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
            'token': token
        },
        timeout: 3000
    })
        .then(response => {
            return response;
        });
};
